export interface FeatureFlags {
  recurringTransactions: boolean;
}

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  recurringTransactions: false,
};
